<template>
    <div v-if="settings" id="us-section">
        <img :src="settings.contact_image.url" alt="تماس با ما میرداماد">
        <div>
            <h2>تماس ما</h2>
            <p>{{settings.contact_text.value}}</p>
        </div>
    </div>
</template>
<script>
export default {
    computed:{
        settings(){
          return  this.$store.getters.getSettings;
        }
    },
     metaInfo() {
    return {
      title: "تماس با ما",
      meta: [
        {
          name: "description",
          content:
            "برای ارتباط با بانک کتاب های میرداماد میتوانید این لیست را مشاهده کنید"
        },
        {
          property: "og:title",
          content:"تماس با ما"
        },
        { name: "robots", content: "index,follow" }
      ]
    };
  }
}
</script>